<template>
	<invoices-table v-if="active"
		:invoices="invoices"
		:top-paging="false"
		:show-property="false"
		title-bar
		actionable>
	</invoices-table>
</template>
<script>
import InvoicesTable from '@/Pages/Backend/Invoices/Table'

export default {
	components: {
		InvoicesTable
	},
	props: {
		invoices: {
			type: [Array, Object],
			default: () => {},
			required: true
		},
		active: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			//
		}
	},
	watch: {
		active () {
			// Reset query string, so we don't confuse the other data tables
			window.history.pushState({}, document.title, window.location.pathname)
		}
	}
}
</script>
